export default {"src":"/oferta/_next/static/media/logo-white.4a583723.svg","height":40,"width":223,"blurWidth":0,"blurHeight":0};